<script setup lang="ts">
import { computed } from "vue";
import { bemBuilder } from "@chatfood/core-utils";
import { AtomText, SatProgressTracker } from "@chatfood/design-system";
import { useCustomerStore } from "~/stores/customer";
import { useLocale } from "~/composables/use-locale";

const css = bemBuilder("loyalty-progression");

const customer = useCustomerStore();

const { t } = useLocale();

const nextTierPoints = computed(() => {
  if (!customer.loyalty.tier || !customer.loyalty.nextTier?.name) {
    return "";
  }

  return t("components.loyalty_progression.points_details", {
    points: customer.loyalty.tier.maxPoints - customer.loyalty.lifetimePoints,
    nextTier: customer.loyalty.nextTier.name,
  });
});
</script>

<template>
  <div :class="css('')">
    <AtomText
      v-if="customer.loyalty?.tier?.name"
      data-test="current-tier"
      type="h3"
    >
      {{ customer.loyalty.tier.name }}
    </AtomText>
    <AtomText
      v-if="nextTierPoints"
      data-test="next-tier"
      color="color-text-secondary"
    >
      {{ nextTierPoints }}
    </AtomText>
    <SatProgressTracker
      v-if="customer.loyalty.tier"
      :min="customer.loyalty.tier?.minPoints"
      :max="customer.loyalty.tier?.maxPoints"
      :current="customer.loyalty.lifetimePoints"
    />
    <AtomText
      v-if="customer.loyalty.tier?.description"
      tag="div"
      data-test="tier-details"
      :class="css('description')"
    >
      {{ customer.loyalty.tier.description }}
    </AtomText>
  </div>
</template>

<style lang="scss" scoped>
.loyalty-progression {
  padding: var(--spacing-md);

  &__description {
    margin-top: var(--spacing-lg);
  }
}
</style>
